import React from 'react';
import { Button, Tooltip, Row, Col, Modal, message } from 'antd';
import AssetRepository from '../../components/adms/AssetRepository'
import NewElement from '../../components/adms/NewElement';
import Taxonomy from '../../components/skos/Taxonomy';
import Tags from '../../components/tags/Tags';
import Langs from '../../components/langs/Langs';
import Alphabet from '../../components/alphabet/Alphabet';
import Search from '../../components/search/Search';
import FilterData from '../../components/filter/FilterData';
import { RdfTriplet, AdmsRepository } from '../../redux';
import { subsetByLangOrEmpty, getCountValue } from '../../virtuoso/helper';
import i18n from "i18next";

const showAdd = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: 700}} visible={true} title="Добавление нового элемента в каталог" cancelText="Отменить" okText="Добавить" 
		onCancel={onCancelOperation} onOk={onFinishOperation}>	
        <NewElement wrappedComponentRef={formRef} />
	  </Modal>
}

/** Добавить условие в список. Для словий с одной схемой формируется массив значений */
const includedConditions = (conditions, condition) => {
  //Проверим, что такая схема есть и тогда сделаем массив значений
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (!Array.isArray(scheme[0].value))
      scheme[0].value = [scheme[0].value];
    scheme[0].value.push(condition.value);
    return conditions;
  }
  return conditions.concat([condition])
}
/** Исключить условие из поиска */
const excludedConditions = (conditions, condition, taxonomy, lang) => {
  //console.log("AssetList.js excludedConditions", conditions, condition, taxonomy, lang);
  //Проверим, что такая схема есть и тогда исключим из массива значений значение condition
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (Array.isArray(scheme[0].value)){
        scheme[0].value = scheme[0].value.filter(item => item != condition.value)
        if (scheme[0].value.length == 1){
            scheme[0].value = scheme[0].value[0]
            //Надо обновить label, т.к. может он может не совпадать
            //label задаётся при добавлении условия, для массива label - первый заданный condition
            //см. отображение условий в FilterData.js
            const schemes = taxonomy.filter(item => item.IRI && item.IRI.value && (item.IRI.value == condition.scheme));
            const concepts = (schemes.length>0)?subsetByLangOrEmpty(schemes[0].concepts, lang, "IRI", "Label"):[];
            const labels = concepts.filter(concept => concept.IRI.value == scheme[0].value);
            scheme[0].label = (labels.length>0)?labels[0].Label.value:scheme[0].value;
        }
        return conditions;
    }
  }
  return conditions.filter(item => !((item.predicate==condition.predicate)&&(item.operator==condition.operator)&&(item.value==condition.value)));
}
/** Компонента для получения и отображения списка активов. 
 *  Доступные активы фиксируются в vadms.
 * Линковка props и vadms происходит в containers.js
 */
class AssetList extends React.Component {

    state = {
      modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог добавление нового элемениа
    };

    saveFormRef = formRef => {
      this.formRef = formRef;
    }
  
    //Событие об изменение состава условий отбора
    // include - true - добавить условие, false - удалить условие.
    // condition - само условие. 
    // Если условия из одной схемы, то создать массив, который будет объединятся по ИЛИ
    onChangeListConditions (include, condition) {
        //console.log("AssetList.js",this, include, condition);
        const {conditions, actions, taxonomy, lang, onChangeConditions} = this.props;
        const filter = (include)? includedConditions(conditions, condition) : excludedConditions(conditions, condition, taxonomy, lang);
        if (onChangeConditions) onChangeConditions(AdmsRepository, filter);
    }

    onSearchByAlphabet(include, char){
      const {onAlphabetSearch, conditions} = this.props;
      if (onAlphabetSearch) onAlphabetSearch(AdmsRepository, (include)?char:"", conditions);      
    }

    onSearchByName (pattern) {
      //console.log("onSearchByName (pattern)", pattern, this);
      const {onNameSearch, conditions} = this.props;
      if (onNameSearch) onNameSearch(AdmsRepository, pattern, conditions);
    }

    onRefresh (e) {
      e.preventDefault();
      const {conditions} = this.props;
      this.props.onRefreshList(AdmsRepository, conditions);
    }
    onNewAsset(e){
      e.preventDefault();
      this.setState({modal:"add"});
    }

    cancelOperation(){
      this.setState({modal:"none"});
    }
  
    /** Вызывается при добавлении новой карточки. Данные см. NewElement.js */
    submitOperation() {
      const { form } = this.formRef.props;
      //console.log('submitOperation() ', this);
      form.validateFields((err, values) => {
        if (err) return; //console.log("Received values of form: ", values);
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))? values.IRI : "http://www.w3.org/ns/adms#"+values.IRI;
        //Проверим, что IRI отсутсвует
        RdfTriplet.countSubject(IRI)
          .then ( response =>{
            const count = getCountValue(response.bindings);
            if (count>0){
              message.error(`IRI ${IRI} уже существует. Задайте другой идентификатор.`);
              return;
            }
            const catalog = "http://hbz.ru/adms/catalog";
            this.props.onAddElement(AdmsRepository, catalog, IRI, values.type, values.label.text, values.label.lang)
              .then (response =>{ 
                //const time = showMessageSuccess(store, "Добавление записи завершено успешно.");
                message.success("Добавление записи завершено успешно.");
                this.setState({modal:"none"}); 
              })
              .catch(e => {  message.error(`Ошибка при добавлении элемента в каталог. ${e}`); });                  
          })
          .catch(e => {  message.error(`Не удалось определить уникальность IRI. ${e}`); });
      });
    };
  
    render() {
        console.log(this);
        const { modal } = this.state;
        const {taxonomy, conditions, isSignedIn} = this.props;
        //Условия отбора задаются в vadms см. AdmsActions с использованием действий добавления/удаления условия 
        const isCondition = (conditions && Array.isArray(conditions))?conditions.length>0: false;
        return (
            <div>
                <Row>
                    <Col className="csi_search_bar_title" span={6} style={{}}></Col>
                    <Col className="csi_search_form_div" span={18} style={{}}><Search onSearch={(value) => this.onSearchByName(value)} /></Col>
                </Row>
                <Row>
                    <Col className="csi_filters" span={6} style={{}}>
                        {isCondition && (<Row style={{}} className="filterBrowserDiv"> <FilterData onChange={(i,c)=> this.onChangeListConditions(i,c)}/></Row>)}
                        <Row style={{}}> <Taxonomy selected={conditions} taxonomy={taxonomy} onChange={(i,c)=> this.onChangeListConditions(i,c)}/></Row>
                        <Row style={{display: "none"}}> <Tags/></Row>
                    </Col>
                    <Col className="csi_asset_list" span={18} style={{}}>
                        <Row><Alphabet selected={conditions} onChange={(i,c)=> this.onSearchByAlphabet(i,c)} /></Row>                            
                        <Row>
                            <Col style={{display: "none"}} span={23}>Язык каталога моделей  <Langs /></Col>
                            <Col span={24}>
                              {isSignedIn &&(
                                <Tooltip placement="top" title={i18n.t('views.adms.list_add_title')}>
                                  <Button icon="file-add" onClick={(e)=> this.onNewAsset(e)}></Button>
                                </Tooltip>
                              )}
                                <Tooltip placement="top" title={i18n.t('views.adms.list_reload_title')}>
                                  <Button icon="cloud-sync" onClick={(e)=> this.onRefresh(e)}></Button>
                                </Tooltip>
                            </Col>
                            </Row>
                        <Row><AssetRepository  {...this.props} /></Row>
                    </Col>
                </Row>
                {(modal=="add" )&& showAdd( this.saveFormRef, ()=>this.submitOperation(), ()=>this.cancelOperation())}
            </div>            
        )
    }
}

export default AssetList;